import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useTryoutHome } from '@/features/tryout-home/composables'
import { useEventViewStore, eventViewAccess, resolveEventView } from '@/stores/eventView'
import type { EventView } from '@/stores/eventView'
export function useEventView() {
  const route = useRoute(), auth = useAuthStore(), store = useEventViewStore()
  const scope = computed(() => ({viewerId: String(auth.user?.details?.id || auth.user?.id || ''), clubId: String(route.params.clubId || ''), seasonId: String(route.params.seasonId || ''), eventId: String(route.params.tryoutId || '')}))
  const active = computed(() => Object.values(scope.value).every(Boolean))
  const home = computed(() => `/clubhouse/${encodeURIComponent(scope.value.clubId)}/season/${encodeURIComponent(scope.value.seasonId)}/tryout/${encodeURIComponent(scope.value.eventId)}`)
  const isHome = computed(() => route.path.replace(/\/$/,'') === home.value)
  // Reuse the shared viewer-scoped V2 home query for role checks and page data.
  const query = useTryoutHome(computed(() => scope.value.seasonId), computed(() => scope.value.eventId), computed(() => scope.value.clubId))
  const roles = computed(() => query.data.value?.event?.roles || {})
  const access = computed(() => eventViewAccess(roles.value))
  const mode = computed(() => query.isSuccess.value ? resolveEventView(store.preference(scope.value), roles.value) : null)
  const canChoose = computed(() => access.value.athlete && access.value.staff)
  const select = (view: EventView) => store.select(scope.value, view, roles.value)
  // Existing links may request a view on the home page. Journal's ?view=contents is unrelated.
  watch([isHome, () => route.query.view, roles], () => {
    if (!isHome.value) return
    if (route.query.view === 'athlete') select('athlete')
    else if (route.query.view === 'staff' || route.query.view === 'admin') select('staff')
  }, {immediate:true})
  return {scope, active, home, isHome, query, roles, access, mode, canChoose, select}
}
